import { styled } from '@mui/system'

type FavProps = {
  size: string
}

export const StarStyle = styled('div')<FavProps>(
  ({ size }) => ({
    display: 'inline-block',
    cursor: 'pointer',
    '& > svg': {
      width: (size === 'large') ? 20 : 16,
      height: (size === 'large') ? 32 : 16,
      margin: 0,
      padding: 0,
      verticalAlign: 'baseline',
    },
  })
)
